import * as React from 'react';

import './DashboardMenu.scss';

import { goToHome } from 'src/utils/navigation';

interface IDashboardMenuProps {
  signout: () => void;
  getAccounts(): void;
  isMobile?: boolean;
  isLoggedIn: boolean;
  accountID: string;
  showSwitchAccounts: boolean;
  t?: any;
  location?: any;
}

export default class Menu extends React.Component<IDashboardMenuProps, any> {
  constructor(props: any) {
    super(props);
  }

  private logOut = () => {
    this.props.signout();
    goToHome();
  };

  public render() {
    const { t } = this.props;
    return (
      <div id="rp-dashboard-menu" className="no-select">
        {this.props.isLoggedIn && (
          <div className="rp-dashboard-menu--menu-item">
            <div className="logged-in">
              <span className="menu-item" onClick={this.logOut}>
                <i className="rpds-power-on" />
                {t('common.logOut')}
              </span>
            </div>
          </div>
        )}
      </div>
    );
  }
}
